module.exports = __webpack_public_path__ + "./assets/logo-omds-gray__5afc7bde2a69935aef84b80148c0bfc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-omds-gray.png
// module id = 707
// module chunks = 32